// Presentation.jsx
import { Link } from 'react-router-dom';
import './Presentation.css';

import conti from '../imagesHome/conti.png';



import LoginFirstPage from '../content/loginoptions/LoginFirstPage';
import DownsideBackground from './DownsideBackground';
import PricingPlans from '../PricingPlans/PricingPlans';
import LearnAnywhere from './LearnAnywhere';
import CertificateSection from './CertificateSection';

import ChooseYourCourse from './ChooseYourCourse';
import CourseBar from './CourseBar';








export const Presentation = () => {
  return (
    <main>
    
      
<div className="hero-login-split">
  <div className="hero-login-split__left">
    <img src={conti} alt="Mascota ContaLearn" className="hero-login-split__image" />
  </div>
  <div className="hero-login-split__right">
    <LoginFirstPage />
  </div>
</div>

<CourseBar />
<ChooseYourCourse />
<CertificateSection />
<LearnAnywhere />

<PricingPlans />


    <DownsideBackground />
      

 




     
    </main>
  );
};
